angular.module('storefrontApp')
    .component('rsQuantityInput', {
        templateUrl: 'themes/assets/js/common-components/rsQuantityInput.tpl',
        bindings: {
            change: '=',
            quantity: '=',
            productId: '<',
            blurChange: '<',
        },
        controller: ['$scope', function ($scope) {
            const $ctrl = this;

            $scope.$watch('$ctrl.quantity', function () {
                if ($ctrl.quantity === undefined) {
                    $ctrl.quantity = 1;
                    return;
                }

                if ($ctrl.quantity > 999) {
                    $ctrl.quantity = 999;
                    return;
                }

                if ($ctrl.quantity < 1) {
                    $ctrl.quantity = 1;
                }
            });

            // The 1..999 bound used to be enforced by CSS alone (div.disabled sets
            // pointer-events: none). The steppers are keyboard-operable buttons now,
            // so the bound lives here and drives their aria-disabled state.
            $ctrl.canDecrease = function () {
                return $ctrl.quantity > 1;
            };

            $ctrl.canIncrease = function () {
                return $ctrl.quantity < 999;
            };

            $ctrl.changeQuantity = function (newQuantity) {
                if ($ctrl.quantity === newQuantity || newQuantity < 1 || newQuantity > 999) {
                    return;
                }

                if ($ctrl.change) {
                    $ctrl.change($ctrl.productId, newQuantity);
                } else {
                    $ctrl.quantity = newQuantity;
                }
            };

            $ctrl.focusQuantity = function () {
                $ctrl.quantityOnFocus = $ctrl.quantity;
            };

            $ctrl.blurQuantity = function () {
                if ($ctrl.quantity === $ctrl.quantityOnFocus) {
                    return;
                }

                if ($ctrl.blurChange && $ctrl.change) {
                    $ctrl.change($ctrl.productId, $ctrl.quantity);
                }
            };
        }],
    });
